<template>

	<div class="account-actions centered">

		<a href="/order" class="button secondary">New order</a>

		<button @click.prevent="showLoginModal()" class="button primary">Log in</button>

	</div>

</template>


<script>

    export default {

        methods: {


            showLoginModal () {
                this.$modal.show('LoginModal',)

            },

        },
    }
</script>